import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { FaExternalLinkAlt, FaChevronDown } from "react-icons/fa";
import { routeNames } from "../../../routes/routeNames";
import { IoIosArrowDown } from "react-icons/io";

import {
  homeBanners,
  mainLogo,
} from "../../../config";
import {
  dropDownServices,
  dropDownSpecialities,
  services,
  specialitiesData,
} from "../../../utils/Data";
import "./index.css";
import { newServices, newSpecialities } from "../../../utils/NewData";
import ContactButton from "../ContactButton";

// Array of banner images for the slideshow
const bannerImages = [homeBanners.bannerOne, homeBanners.bannerTwo, homeBanners.bannerThree];

const MainBanner = ({
  bannerTitle = "Main Title",
  banenrHeadline,
  bannerDescription,
  showTopBar = true,
  showContactButton = true,
  mainBannerImages = bannerImages
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fadeTransition, setFadeTransition] = useState(true);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showSpecialtiesDropdown, setShowSpecialtiesDropdown] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 100) {
  //       setIsScrolled(true);
  //     } else {
  //       setIsScrolled(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);
  // State to manage dropdown visibility
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isDropdownSpecOpen, setDropdownSpecOpen] = useState(false);

  // Function to open dropdown
  const handleMouseEnter = () => {
    setDropdownOpen(true);
  };

  // Function to close dropdown
  const handleMouseLeave = () => {
    setDropdownOpen(false);
  };

  // Change banner image every 5 seconds with fade effect
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeTransition(false); // Start fade out

      setTimeout(() => {
        setCurrentImageIndex(
          (prevIndex) => (prevIndex + 1) % bannerImages.length
        );
        setFadeTransition(true); // Start fade in
      }, 500); // Transition duration (0.5 second)
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Mouse events for showing and hiding dropdowns

  const handleMouseEnterSpecialties = () => setDropdownSpecOpen(true);
  const handleMouseLeaveSpecialties = () => setDropdownSpecOpen(false);

  return (
    <section className="relative h-[85vh] bg-gradient-to-t from-secondary to-black text-white text-center overflow-hidden">
      {/* Banner Image Section */}
      <div className="absolute inset-0 z-0">
        {mainBannerImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt="Banner"
           
            className={`w-full h-full object-cover absolute transition-opacity duration-1000 ${
              index === currentImageIndex
                ? "opacity-100 z-20"
                : "opacity-0 z-10"
            }`}
          />
        ))}
      </div>
      {/* Overlay Layer */}
      <div className="absolute inset-0 z-10 bg-black opacity-40"></div>
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-orange-500 via-transparent to-black opacity-70"></div>

      {/* Header */}
      <header
        className={`relative top-0 left-0 right-0 p-4 z-20 transition-all duration-300 ease-in-out ${
          isScrolled
            ? "bg-white text-primary shadow-lg"
            : "bg-transparent text-white"
        }`}
      >
        <div className="mx-4 flex justify-between items-center">
          {/* Logo and Title */}
          <div
            onClick={() => navigate(routeNames.home)}
            className="flex items-center space-x-3 cursor-pointer lg:space-x-2"
          >
            <img src={mainLogo} alt="Logo" className="h-14 w-14" />
            <div className="flex flex-col items-center">
              <h1 className="text-2xl italic font-lato font-bold lg:text-3xl">
                {bannerTitle}
              </h1>
              <div className="flex items-center space-x-2">
                <span className="w-10 h-[1px] bg-green"></span>
                <h3 className="text-md font-lato italic lg:text-md">
                  Feel the Relief
                </h3>
                <span className="w-10 h-[1px] bg-green"></span>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex space-x-8 items-center">
            <div className="relative" onMouseLeave={handleMouseLeave}>
              <button
                id="dropdownInformationButton"
                className={`text-xl font-semibold hover:text-primary focus:ring-4 focus:outline-none focus:text-primary  rounded-lg  py-2.5 text-center inline-flex items-center transition-all duration-300 ease-in-out transform hover:scale-105 ${isDropdownOpen && "text-primary"}`}
                type="button"
                onMouseEnter={handleMouseEnter}
              >
               <div onClick={()=>navigate(routeNames.services)} className="flex items-center"><h3 className="p-1">Services</h3><IoIosArrowDown /></div>
              </button>

              {/* Dropdown content */}
              {isDropdownOpen && (
                <div
                  id="dropdownInformation"
                  className="absolute z-10 bg-background   rounded-lg shadow-lg w-56 py-4 opacity-0 transform transition-all duration-300 ease-in-out scale-90 origin-top-right"
                  onMouseLeave={handleMouseLeave}
                  style={{
                    animation: "fadeInDown 0.3s forwards",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {newServices.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-col space-y-2 px-2 py-1"
                    >
                      <Link
                        to={item.link}
                        className="text-primary hover:text-secondary font-medium transition-colors duration-300 ease-in-out"
                      >
                        {item.title}
                      </Link>
                      {index < newServices.length - 1 && (
                        <hr className="border-t border-gray-200" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className="relative"
              onMouseLeave={handleMouseLeaveSpecialties}
            >
              <button
                id="dropdownInformationButton"
                className={`text-xl font-semibold hover:text-primary focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg  py-2.5 text-center inline-flex items-center transition-all duration-300 ease-in-out transform hover:scale-105 ${isDropdownSpecOpen && "text-primary"}`}
                type="button"
                onMouseEnter={handleMouseEnterSpecialties}
              >
                <div onClick={()=>navigate(routeNames.specialities)} className="flex items-center"><h3 className="p-1">Specialities</h3><IoIosArrowDown /></div>
              </button>

              {/* Dropdown content */}
              {isDropdownSpecOpen && (
                <div
                  id="dropdownInformation"
                  className="absolute z-10 bg-background   rounded-lg shadow-lg w-56 py-4 opacity-0 transform transition-all duration-300 ease-in-out scale-90 origin-top-right"
                  onMouseLeave={handleMouseLeaveSpecialties}
                  style={{
                    animation: "fadeInDown 0.3s forwards",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {newSpecialities.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-col space-y-2 px-2 py-1"
                    >
                      <Link
                        to={item.link}
                        className="text-primary hover:text-secondary font-medium transition-colors duration-300 ease-in-out"
                      >
                        {item.title}
                      </Link>
                      {index < newSpecialities.length - 1 && (
                        <hr className="border-t border-gray-300" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* <Link
              to={routeNames.patientinfo}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              Patient Info
            </Link> */}
            <Link
              to={routeNames.Blog}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              Our Blog
            </Link>
            <Link
              to={routeNames.aboutus}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              About Us
            </Link>
            <Link
              to={routeNames.contact}
              className="inline-block bg-primary text-white py-2 px-6 rounded-full font-primary text-md font-semibold shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-secondary hover:to-primary"
            >
              Contact Us
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="xl:hidden text-white" onClick={toggleMenu}>
            {isOpen ? (
              <XIcon className="h-6 w-6" />
            ) : (
              <MenuIcon className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-30 xl:hidden">
            <nav className="absolute right-0 top-0 w-[75%] h-full bg-gray-100 text-primary p-8 flex flex-col space-y-4">
              <button className="self-end" onClick={toggleMenu}>
                <XIcon className="h-6 w-6 text-primary" />
              </button>
              <div
                onClick={() => navigate(routeNames.home)}
                className="flex items-center space-x-2 cursor-pointer"
              >
                <img src={mainLogo} alt="Logo" className="h-10 w-10" />
                <h1 className="text-xl font-bold">{bannerTitle}</h1>
              </div>

              <div className="mt-10"></div>

              <Link
                to="/"
                className="text-lg text-start font-semibold "
                onClick={toggleMenu}
              >
                Home
              </Link>
              <div className="border-t border-gray-300 w-full "></div>
              <Link
                to={routeNames.services}
                className="text-lg text-start font-semibold"
                onClick={toggleMenu}
              >
                Services
              </Link>
              <div className="border-t border-gray-300 w-full"></div>
              <Link
                to={routeNames.specialities}
                className="text-lg text-start font-semibold"
                onClick={toggleMenu}
              >
                Specialties
              </Link>
             
              {/* <Link
                to={routeNames.testinomials}
                className="text-lg text-start font-semibold"
                onClick={toggleMenu}
              >
                Testimonials
              </Link> */}
              <div className="border-t border-gray-300 w-full"></div>
              <Link
                to={routeNames.Blog}
                onClick={toggleMenu}
                className="text-lg text-start font-semibold"
              >
                Our Blog
              </Link>
              
              <Link
                onClick={toggleMenu}
                to={routeNames.contact}
                className="inline-block bg-primary text-white py-2 px-8 rounded-full font-primary text-md font-semibold shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-secondary hover:to-primary"
              >
                Contact Us
              </Link>
            </nav>
          </div>
        )}
      </header>

      {/* Banner Content */}
      <section className="relative h-full flex flex-col justify-center items-center z-10">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-extrabold text-white mb-6 lg:text-5xl">
            {banenrHeadline}
          </h2>
          <p className="text-lg font-semibold mb-8 text-white">{bannerDescription}</p>
          {showContactButton && <ContactButton/>}
        </div>
      </section>
    </section>
  );
};

export default MainBanner;
